<template>
  <family-page-wrapper class="family-ride-credits">
    <h5 class="pb-10">
      You can use this page to view and add GoGo Credits to your account.
    </h5>

    <add-ride-credits />
    <transactions />
    <expiring-credits />
  </family-page-wrapper>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

const Transactions = defineAsyncComponent(() => import('./RideCredits/Transactions.vue') as any);

const AddRideCredits = defineAsyncComponent(() => import('@/components/Main/Shared/AddRideCredits.vue') as any);

const ExpiringCredits = defineAsyncComponent(() => import('@/components/Main/Operator/Payments/ExpiringCredits.vue') as any);
</script>
